import React, { useCallback } from 'react';
import * as Mui from '@mui/material';
import { RenderFieldProps } from '@/types/form';

const TextField = ({ field, value, id, onChange }: RenderFieldProps) => {
  const handleTextChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(id, e.target.value),
    [id, onChange]
  );

  return (
    <Mui.TextField
      label={field.label}
      required={field.required}
      value={value ?? ''}
      onChange={handleTextChange}
      fullWidth
      margin="normal"
      variant="outlined"
    />
  );
};

export default React.memo(TextField);